export default "__VITE_ASSET__C236lxiD__"